import * as React from 'react';
import { connect } from 'react-redux';
import { Popper, Grow, Paper, ClickAwayListener, MenuList, MenuItem } from '@material-ui/core';
import { IAuthState, IToken, UserTypes } from 'src/modules/Auth/store/types';
import { IReduxState } from 'src/reduxTypes';
import './agencyFilter.css'

export interface IAgencyFilterProps {
  auth: IAuthState;
  changeAgency: (agencyCode: string) => void;
  showOnlyAdmin?: boolean;
  loading: boolean;
}

export interface IAgencyFilterState {
  agencyToken: string;
  selected: string;
  toggleFilter: boolean;
}

class AgencyFilter extends React.Component<IAgencyFilterProps, IAgencyFilterState> {
  constructor(props: IAgencyFilterProps) {
    super(props);
    const agencyToken = this.getAgencyToken();
    this.state = {
      agencyToken,
      selected: agencyToken,
      toggleFilter: false
    }
  }
  public getAgencyToken() {
    const { idToken } = this.props.auth;
    return (idToken as IToken).payload["custom:agencyCode"];
  }
  public toggleFilter = (selected?) => {
    this.setState((state) => ({
      toggleFilter: !state.toggleFilter,
      selected: typeof selected === "string" ? selected : state.selected
    }))
  }
  public changeAgency = (agencyCode) => () => {
    this.toggleFilter(agencyCode);
    this.props.changeAgency(agencyCode);
  }
  public isAdmin() {
    return this.props.auth.userType === UserTypes.ADMIN;
  }
  public render() {
    const { agencies } = this.props.auth
    const show = !this.props.showOnlyAdmin ? true : this.props.showOnlyAdmin && this.isAdmin()
    return show ? (
      <h3 className={'agencyFilter'}>
        {this.state.selected === 'ALL' ? 'GLOBAL' : this.state.selected}
        <div className={"filter"}>
          <p onClick={() => !this.props.loading && this.setState({ toggleFilter: true })}>
            <i className="fa fa-filter" aria-hidden="true" />
            Filter
        </p>
          <Popper className="filterPopper" open={this.state.toggleFilter} transition={true} disablePortal={true} >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={this.toggleFilter}>
                    <MenuList>
                      <MenuItem onClick={this.changeAgency('ALL')}>GLOBAL</MenuItem>
                      {this.state.agencyToken !== "ALL" && <MenuItem onClick={this.changeAgency(this.state.agencyToken)}>{this.state.agencyToken}</MenuItem>}
                      {this.state.agencyToken === "ALL" && agencies && (agencies).map((agency) => {
                        return <MenuItem onClick={this.changeAgency(agency.code)} key={agency.code}>{agency.name}</MenuItem>
                      })}
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>

      </h3>
    ) : null;
  }
}
const mapStateToProps = (state: IReduxState) => ({
  auth: state.auth
});

export default connect(mapStateToProps)(AgencyFilter);